import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { blue } from "@ant-design/colors";

import { Box, Flex, IconButton, Typography } from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import { Button, Modal, Popconfirm, Table, Card } from "antd";
import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Template from "../../asset/form/4. Mau_ly_lich_KH.docx";
import TemplateEn from "../../asset/form/Science_resume_template.docx";
import {
  deleteCommercializationMission,
  deleteScienceMission,
  deleteDiploma,
  deleteMonograph,
  deleteScienceArticle,
  deleteInventionAward,
} from "../../util/API";
import { dateFormatList, infoList } from "../../util/helper";
import {
  Prizesv2,
  SciencePrize,
  CommercializationMission,
  Diploma,
  Monograph,
  ScienceMission,
  ScientificArticle,
} from "../form";
import UploadFile from "../uploadFile";

const ScienceTab = ({
  dataForUpdate,
  setDataForUpdate,
  isSecretariatView = false,
}) => {
  const { t, i18n } = useTranslation();
  const [scienceProfileCurrentPage, setScienceProfileCurrentPage] = useState(1);
  const [monographCurrentPage, setMonographCurrentPage] = useState(1);
  const [scienceArticleCurrentPage, setScienceArticleCurrentPage] = useState(1);
  const [scienceMissionCurrentPage, setScienceMissionCurrentPage] = useState(1);
  const [sciencePrizeCurrentPage, setSciencePrizeCurrentPage] = useState(1);
  const [scienceDiplomaCurrentPage, setScienceDiplomaCurrentPage] = useState(1);
  const [commercializationCurrentPage, setCommercializationCurrentPage] =
    useState(1);

  const [pageSize, setPageSize] = useState(25);

  const [fileList, setFileList] = useState([]);
  const [fileList1, setFileList1] = useState([]);
  const [fileList2, setFileList2] = useState([]);

  //#region Form
  const [curObject, setCurObject] = useState(null);
  const [curIndex, setCurIndex] = useState(null);
  const [key, setKey] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [modalTile, setModalTitle] = useState("");
  //#endregion

  //#region currenPage table
  const [scientificMissionsCurrentPage, setScientificMissionsCurrentPage] = useState(1);
  const [scientificArticleCurrentPage, setScientificArticleCurrentPage] = useState(1);
  const [inventionAwardsCurrentPage, setInventionAwardsCurrentPage] = useState(1);
  const [diplomasCurrentPage, setDiplomasCurrentPage] = useState(1);
  const [commercializationMissionsCurrentPage, setCommercializationMissionsCurrentPage] = useState(1);
  const [monographsCurrentPage, setMonographsCurrentPage] = useState(1);
  const [prizesV2CurrentPage, setPrizesV2CurrentPage] = useState(1);
  const [pageSizeTable, setPageSizeTable] = useState(10);
  //#endregion

  const [downloadTemplate, setDownloadTemplate] = useState(null);

  //#region Columns
  const scienceProfileColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (scienceProfileCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_proof_of_ability")}`,
      key: "name",
      render: (value, record, index) => t(record?.name),
    },
    {
      title: `${t("str_attach_link")}`,
      dataIndex: "url",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() => handleShowModal("prizes_v2", record, index)}
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeletePrizev2(index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );
        return null;
      },
    },
  ];

  const monographColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (monographCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_book_title")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_book_author_co_author")}`,
      dataIndex: "author_name",
    },
    {
      title: `${t("str_publisher")}`,
      dataIndex: "publisher",
    },
    {
      title: `${t("str_book_year_of_publication")}`,
      dataIndex: "year",
    },
    {
      title: `${t("str_isbn")}`,
      dataIndex: "isbn_index",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() => handleShowModal("monograph", record, index)}
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteMonograph(record, index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );
        return null;
      },
    },
  ];

  const scientificArticleColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (scienceArticleCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_title_article_report")}`,
      dataIndex: "project_name",
    },
    {
      title: `${t("str_author_co_author")}`,
      dataIndex: "author_name",
    },
    {
      title: `${t("str_magazine")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_book_year_of_publication")}`,
      dataIndex: "year",
    },
    {
      title: `${t("str_issn_isbn")}`,
      dataIndex: "issn_isbn",
    },
    {
      title: `${t("str_isi")}`,
      dataIndex: "classify",
    },
    {
      title: `${t("str_if_index")}`,
      dataIndex: "if_index",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("scientific_article", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteScienceArticle(record, index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const scienceMissionColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (scienceMissionCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_task_name")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_sponsor")}`,
      dataIndex: "funding_agency",
    },
    {
      title: `${t("str_start_time")}`,
      key: "started_at",
      render: (value, record) => (
        <span>
          {record?.started_at
            ? dayjs(record?.started_at).format(dateFormatList[0])
            : null}
        </span>
      ),
    },
    {
      title: `${t("str_end_time")}`,
      key: "end_at",
      render: (value, record) => (
        <span>
          {record?.end_at
            ? dayjs(record?.end_at).format(dateFormatList[0])
            : null}
        </span>
      ),
    },
    {
      title: `${t("str_role")}`,
      dataIndex: "position",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("science_mission", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteScienceMission(record, index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const sciencePrizeColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (sciencePrizeCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_name_award")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_author_co_author")}`,
      dataIndex: "author_name",
    },
    {
      title: `${t("str_awarded_by")}`,
      dataIndex: "organization_name",
    },
    {
      title: `${t("str_year_of_award")}`,
      dataIndex: "year",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("science_prize", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteInventionAward(record, index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const scienceDiplomaColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (scienceDiplomaCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_document_name")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_author_co_author")}`,
      dataIndex: "author_name",
    },
    {
      title: `${t("str_issued_number")}`,
      dataIndex: "index",
    },
    {
      title: `${t("str_issued_by")}`,
      dataIndex: "organization_name",
    },
    {
      title: `${t("str_year_of_issue")}`,
      dataIndex: "year",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() => handleShowModal("diploma", record, index)}
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteDiploma(record, index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const commercializationColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (commercializationCurrentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_product_name")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_author_co_author")}`,
      dataIndex: "author_name",
    },
    {
      title: `${t("str_application_format")}`,
      dataIndex: "form",
    },
    {
      title: `${t("str_year_of_implementation")}`,
      dataIndex: "year",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("commercialization_mission", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>

              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() =>
                    handleDeleteCommercializationMission(record, index)
                  }
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];
  //#endregion

  useEffect(() => {
    if (i18n.language === "en") setDownloadTemplate(TemplateEn);
    else setDownloadTemplate(Template);
  }, [i18n.language]);

  useEffect(() => {
    if (dataForUpdate?.background) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.background?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });
      setFileList([...tmp]);
    } else {
      setFileList([]);
    }
  }, [dataForUpdate?.background]);

  useEffect(() => {
    if (dataForUpdate?.certificate_files) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.certificate_files?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });

      setFileList1([...tmp]);
    } else {
      setFileList1([]);
    }
  }, [dataForUpdate?.certificate_files]);

  useEffect(() => {
    if (dataForUpdate?.attachments) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.attachments?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });

      setFileList2([...tmp]);
    } else {
      setFileList2([]);
    }
  }, [dataForUpdate?.attachments]);

  const handleChangeBackground = (resFile) => {
    let temp = [...(dataForUpdate?.background || [])];
    temp.push(resFile?.id);
    setDataForUpdate({
      ...dataForUpdate,
      background: [...temp],
    });
  };

  const handleChangeFile2 = (resFile) => {
    let temp = [...(dataForUpdate?.certificate_files || [])];
    temp.push(resFile?.id);
    setDataForUpdate({
      ...dataForUpdate,
      certificate_files: [...temp],
    });
  };

  const handleChangeFile3 = (resFile) => {
    let temp = [...(dataForUpdate?.attachments || [])];
    temp.push(resFile?.id);
    setDataForUpdate({
      ...dataForUpdate,
      attachments: [...temp],
    });
  };

  const handleRemoveBackground = (id) => {
    let tmp = [...dataForUpdate?.background];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({ ...dataForUpdate, background: tmp });
    }
  };

  const handleRemoveFile1 = (id) => {
    let tmp = [...dataForUpdate?.certificate_files];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({ ...dataForUpdate, certificate_files: tmp });
    }
  };

  const handleRemoveFile2 = (id) => {
    let tmp = [...dataForUpdate?.attachments];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({ ...dataForUpdate, attachments: tmp });
    }
  };

  //#region Delete functions
  const handleDeleteCommercializationMission = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteCommercializationMission(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.commercialization_missions];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      commercialization_missions: [...temp],
    });
  };

  const handleDeleteMonograph = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteMonograph(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.monographs];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      monographs: [...temp],
    });
  };

  const handleDeleteScienceArticle = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteScienceArticle(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.scientific_articles];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      scientific_articles: [...temp],
    });
  };

  const handleDeleteScienceMission = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteScienceMission(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.science_missions];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      science_missions: [...temp],
    });
  };

  const handleDeleteInventionAward = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteInventionAward(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.invention_awards];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      invention_awards: [...temp],
    });
  };

  const handleDeleteDiploma = async (record, index) => {
    if (record?.id) {
      try {
        const res = await deleteDiploma(record?.id);
        if (res.status === 200) {
        }
      } catch (err) {}
    }
    let temp = [...dataForUpdate?.diplomas];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      diplomas: [...temp],
    });
  };

  const handleDeletePrizev2 = (index) => {
    let temp = [...dataForUpdate?.prizes_v2];

    if (index < 3) {
      temp[index]["url"] = "";
    } else {
      temp.splice(index, 1);
    }

    setDataForUpdate({
      ...dataForUpdate,
      prizes_v2: [...temp],
    });
  };
  //#endregion

  //#region Modal
  const handleShowModal = (key, object = null, index = null) => {
    setKey(key);
    setCurObject(object);

    switch (key) {
      case infoList.prizes_v2:
        setCurIndex(object ? index + (prizesV2CurrentPage - 1)*pageSizeTable : index);
        setModalTitle(t("str_edit_info"));
        break;
      case infoList.monograph:
        setCurIndex(object ? index + (monographsCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_monograph_curriculum"));
        break;
      case infoList.scientific_article:
        setCurIndex(object ? index + (scientificArticleCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_scientific_journals"));
        break;
      case infoList.science_mission:
        setCurIndex(object ? index + (scientificMissionsCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_scientific_task"));
        break;
      case infoList.science_prize:
        setCurIndex(object ? index + (inventionAwardsCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_science_technology_awards"));
        break;
      case infoList.diploma:
        setCurIndex(object ? index + (diplomasCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_issued_patents_for_invention"));
        break;
      case infoList.commercialization_mission:
        setCurIndex(object ? index + (commercializationMissionsCurrentPage- 1)*pageSizeTable : index);
        setModalTitle(t("str_commercialized"));
        break;
    }

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setCurObject(null);
    setCurIndex(null);
    setShowModal(false);
  };

  const handleSubmitModal = () => {
    let temp = [];
    switch (key) {
      case infoList.monograph:
        temp = [...(dataForUpdate?.monographs || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          monographs: [...temp],
        });
        break;
      case infoList.scientific_article:
        temp = [...(dataForUpdate?.scientific_articles || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          scientific_articles: [...temp],
        });
        break;
      case infoList.science_mission:
        temp = [...(dataForUpdate?.science_missions || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          science_missions: [...temp],
        });
        break;
      case infoList.science_prize:
        temp = [...(dataForUpdate?.invention_awards || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          invention_awards: [...temp],
        });
        break;
      case infoList.prizes_v2:
        temp = [...(dataForUpdate?.thesis?.prizes_v2 || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          thesis: {
            ...dataForUpdate.thesis,
            prizes_v2: [...temp],
          },
        });
        break;
      case infoList.diploma:
        temp = [...(dataForUpdate?.diplomas || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          diplomas: [...temp],
        });
        break;
      case infoList.commercialization_mission:
        temp = [...(dataForUpdate?.commercialization_missions || [])];
        if (curIndex !== null && curIndex > -1) {
          temp[curIndex] = { ...curObject };
        } else {
          temp.push(curObject);
        }

        setDataForUpdate({
          ...dataForUpdate,
          commercialization_missions: [...temp],
        });
        break;
    }

    setCurObject(null);
    setCurIndex(null);
    setKey(null);
    setShowModal(false);
  };
  //#endregion

  return (
    <div>
      <Card
        title={
          <span style={{ color: blue.primary }}>
            {t("str_inventions_scientific")}
          </span>
        }
      >
        <Grid gridCols={1} gap={5}>
          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" textTransform="italic">
              <span className="subnotes">{t("str_subnote")}:</span>
              <br />
              <span className="subnotes">1. {t("str_note_from_latest")}</span>
              <br />
              <span className="subnotes">2. {t("str_note_x")}</span>
            </Typography>
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_scientific_task")}
              {/* <span className="subnotes">*</span> */}
            </Typography>

            <Table
              rowKey="id"
              columns={scienceMissionColumns}
              dataSource={dataForUpdate?.science_missions}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setScientificMissionsCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("science_mission", null, dataForUpdate?.science_missions?.length)}
                    >
                      {t("str_add_scientific_task")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_scientific_journals")}
              <span className="subnotes">*</span>
            </Typography>

            <Table
              rowKey="id"
              columns={scientificArticleColumns}
              dataSource={dataForUpdate?.scientific_articles}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setScientificArticleCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("scientific_article", null, dataForUpdate?.scientific_articles?.length)}
                    >
                      {t("str_add_scientific_article")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_science_technology_awards")}
              {/* <span className="subnotes">*</span> */}
            </Typography>
            <Table
              rowKey="id"
              columns={sciencePrizeColumns}
              dataSource={dataForUpdate?.invention_awards}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setInventionAwardsCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("science_prize", null, dataForUpdate?.invention_awards?.length)}
                    >
                      {t("str_add_invention_awards")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_issued_patents_for_invention")}
              {/* <span className="subnotes">*</span> */}
            </Typography>
            <Table
              rowKey="id"
              columns={scienceDiplomaColumns}
              dataSource={dataForUpdate?.diplomas}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setDiplomasCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("diploma", null, dataForUpdate?.diplomas?.length)}
                    >
                      {t("str_add_issued_patents_for_invention")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_commercialized")}
              {/* <span className="subnotes">*</span> */}
            </Typography>
            <Table
              rowKey="id"
              columns={commercializationColumns}
              dataSource={dataForUpdate?.commercialization_missions}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setCommercializationMissionsCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() =>
                        handleShowModal("commercialization_mission", null, dataForUpdate?.commercialization_missions?.length)
                      }
                    >
                      {t("str_add_commercialized")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_monograph_curriculum")}
              {/* <span className="subnotes">*</span> */}
            </Typography>
            <Table
              rowKey="id"
              columns={monographColumns}
              dataSource={dataForUpdate?.monographs}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setMonographsCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("monograph", null, dataForUpdate?.monographs?.length)}
                    >
                      {t("str_add_monograph_curriculum")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} xs={12} s={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_personal_page_link")}
            </Typography>
            <br />

            <Table
              rowKey="id"
              columns={scienceProfileColumns}
              dataSource={dataForUpdate?.thesis?.prizes_v2}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setPrizesV2CurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("prizes_v2", null, dataForUpdate?.thesis?.prizes_v2?.length)}
                    >
                      {t("str_add_proof_of_expertise")}
                    </Button>
                  );

                return null;
              }}
            />
          </GridItem>

          <GridItem col={12} s={12} xs={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_nominee_scientific_cv")}
              <span className="subnotes">*</span>
            </Typography>
            {isSecretariatView && (
            <UploadFile
              fileMimeType={[
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              ]}
              fileTypeAllowNames="pdf/doc/docx"
              // handleUploadSuccess={handleChangeBackground}
              fileList={fileList}
              // handleRemoveFile={handleRemoveBackground}
              disabled={true}
              accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />)}
            {!isSecretariatView && (
              <>
                <a
                  href={downloadTemplate}
                  download="Mau_ly_lich_KH.docx"
                  style={{ marginLeft: "15px", fontSize: "12px" }}
                >
                  {t("str_download_template")}
                </a>
                <br />
                <span className="subnotes">{t("str_file_pdf_word")}</span>
                <br />
                <UploadFile
                  fileMimeType={[
                    "application/pdf",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  ]}
                  fileTypeAllowNames="pdf/doc/docx"
                  handleUploadSuccess={handleChangeBackground}
                  fileList={fileList}
                  handleRemoveFile={handleRemoveBackground}
                  accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
              </>
            )}
          </GridItem>

          <GridItem col={12} s={12} xs={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_degree_certificate")}
              <span className="subnotes">*</span>
            </Typography>
            <br />
            {isSecretariatView && (
            <UploadFile
                  fileMimeType={["application/pdf"]}
                  fileTypeAllowNames="pdf"
                  // handleUploadSuccess={handleChangeFile2}
                  disabled={true}
                  fileList={fileList1}
                  // handleRemoveFile={handleRemoveFile1}
                  accept="application/pdf"
                />)}
            {!isSecretariatView && (
              <>
                <span className="subnotes">{t("str_only_pdf")}</span>
                <br />
                <UploadFile
                  fileMimeType={["application/pdf"]}
                  fileTypeAllowNames="pdf"
                  handleUploadSuccess={handleChangeFile2}
                  fileList={fileList1}
                  handleRemoveFile={handleRemoveFile1}
                  accept="application/pdf"
                />
              </>
            )}
          </GridItem>

          <GridItem col={12} s={12} xs={12}>
            <Typography variant="omega" fontWeight="bold">
              {t("str_other_proofs")}
            </Typography>
            <br />
            {isSecretariatView && (
              <UploadFile
              fileMimeType={["application/pdf"]}
              fileTypeAllowNames="pdf"
              // handleUploadSuccess={handleChangeFile3}
              fileList={fileList2}
              disabled={true}
              // handleRemoveFile={handleRemoveFile2}
              accept="application/pdf"
            />
            )}
            {!isSecretariatView && (
              <>
                <span className="subnotes">{t("str_only_pdf")}</span>
                <br />
                <UploadFile
                  fileMimeType={["application/pdf"]}
                  fileTypeAllowNames="pdf"
                  handleUploadSuccess={handleChangeFile3}
                  fileList={fileList2}
                  handleRemoveFile={handleRemoveFile2}
                  accept="application/pdf"
                />
              </>
            )}
          </GridItem>
        </Grid>
      </Card>
      <Modal
        title={modalTile}
        open={showModal}
        onCancel={handleCloseModal}
        onOk={handleSubmitModal}
        okText={t("str_save")}
        cancelText={t("str_cancel")}
        destroyOnClose
      >
        {key === infoList.prizes_v2 && (
          <Prizesv2 data={curObject} setData={setCurObject} />
        )}
        {key === infoList.monograph && (
          <Monograph data={curObject} setData={setCurObject} />
        )}
        {key === infoList.scientific_article && (
          <ScientificArticle data={curObject} setData={setCurObject} />
        )}
        {key === infoList.science_mission && (
          <ScienceMission data={curObject} setData={setCurObject} />
        )}
        {key === infoList.science_prize && (
          <SciencePrize data={curObject} setData={setCurObject} />
        )}
        {key === infoList.diploma && (
          <Diploma data={curObject} setData={setCurObject} />
        )}
        {key === infoList.commercialization_mission && (
          <CommercializationMission data={curObject} setData={setCurObject} />
        )}
      </Modal>
    </div>
  );
};

export default ScienceTab;
